import { observer } from 'mobx-react-lite'
import { PropsWithChildren, useEffect } from 'react'
import { Platform } from 'react-native'
import { Drawer } from 'react-native-drawer-layout'
import { create } from 'zustand'

import { DrawerContent } from '@/components/Drawer/DrawerContent'
import { rootStore } from '@/models'
import { events } from '@/models/analytics/analytics-events'

type State = {
  status: 'open' | 'close'
}

type Actions = {
  openDrawer: () => void
  closeDrawer: () => void
  toggleDrawer: () => void
}

const openDrawer: Actions['openDrawer'] = () => {
  rootStore?.analytics.setEvent(events.sideNav.drawer_opened)
  useDrawerStore.setState({ status: 'open' })
}

const closeDrawer: Actions['closeDrawer'] = () => {
  rootStore?.analytics.setEvent(events.sideNav.drawer_closed)
  useDrawerStore.setState({ status: 'close' })
}

const toggleDrawer: Actions['toggleDrawer'] = () => {
  const event =
    useDrawerStore.getState().status === 'open' ? events.sideNav.drawer_closed : events.sideNav.drawer_opened
  rootStore?.analytics.setEvent(event)
  useDrawerStore.setState((s) => ({ status: s.status === 'open' ? 'close' : 'open' }))
}

export const useDrawerStore = create<State & Actions>((set) => ({
  status: 'close',
  openDrawer,
  closeDrawer,
  toggleDrawer
}))

export const DrawerComponent = observer(({ children }: PropsWithChildren) => {
  const { status, openDrawer, closeDrawer } = useDrawerStore()
  return (
    <Drawer
      open={status === 'open'}
      onOpen={openDrawer}
      onClose={closeDrawer}
      renderDrawerContent={() => <DrawerContent />}
      drawerType="front"
      drawerPosition="right"
      drawerStyle={{
        zIndex: 99,
        backgroundColor: 'transparent',
        width: '100%',
        alignItems: 'flex-end'
      }}
      swipeEnabled={false}
      overlayStyle={{
        backgroundColor: 'rgba(18, 18, 18, .2)'
      }}
    >
      {children}
    </Drawer>
  )
})
